(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-casas"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ls-casas')){
class LsCasas extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.track=this.querySelector('[data-casa-track]');this.cards=[...this.querySelectorAll('[data-casa-card]')];
  this.gallery=this.dataset.mode==='gallery';
  if(this.gallery||this.dataset.mode==='carousel'){
   const groups=new Map();this.cards.forEach(c=>{const key=c.dataset.author;if(!groups.has(key))groups.set(key,[]);groups.get(key).push(c)});
   groups.forEach(items=>{for(let i=items.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]]}if(!this.gallery)items.splice(2)});
   const ordered=[];let last='';
   while([...groups.values()].some(g=>g.length)){
    const all=[...groups.entries()].filter(([,g])=>g.length),total=all.reduce((n,[,g])=>n+g.length,0);
    let choices=all.filter(([key])=>key!==last);if(!choices.length)choices=all;
    const urgent=choices.filter(([,g])=>g.length>=Math.ceil(total/2));if(urgent.length)choices=urgent;
    let draw=Math.random()*choices.reduce((n,[,g])=>n+g.length,0);let chosen=choices[choices.length-1];for(const pair of choices){draw-=pair[1].length;if(draw<0){chosen=pair;break}}
    ordered.push(chosen[1].pop());last=chosen[0];
   }
   const selected=this.gallery?ordered:ordered.slice(0,Number(this.dataset.limit));this.cards.forEach(c=>{if(!selected.includes(c))c.remove()});this.cards=selected;
  }else this.cards.sort((a,b)=>Number(a.dataset.position)-Number(b.dataset.position));
  this.cards.forEach(c=>this.track.append(c));const cta=this.querySelector('[data-casa-cta]');if(cta){this.track.append(cta);this.cards.push(cta)}
  this.warming=new Set();
  this.videoObserver=new IntersectionObserver(entries=>entries.forEach(e=>{const button=e.target;if(e.isIntersecting&&!button.closest('[data-casa-card]').hidden&&!navigator.connection?.saveData){const video=this.prepareVideo(button);if(this.warming.size<2){this.warming.add(video);video.preload='auto'}}else{const video=button.closest('[data-casa-card]').querySelector('video');if(video){this.warming.delete(video);if(video.paused)video.preload='metadata'}}}),{rootMargin:'100px'});
  this.querySelectorAll('[data-video]').forEach(b=>this.videoObserver.observe(b));
  const filters=this.querySelector('[data-casa-filters]');
  if(filters){const models=new Map();this.cards.forEach(c=>{if(c.dataset.model)models.set(c.dataset.model,c.dataset.modelName)});models.forEach((label,handle)=>{const b=document.createElement('button');b.type='button';b.dataset.filter=handle;b.textContent=label;b.setAttribute('aria-pressed','false');filters.append(b)});filters.addEventListener('click',e=>{const b=e.target.closest('[data-filter]');if(!b)return;filters.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('video').forEach(v=>v.pause());this.cards.forEach(c=>c.hidden=!!b.dataset.filter&&c.dataset.model!==b.dataset.filter);this.querySelector('[data-casa-empty]').hidden=this.cards.some(c=>!c.hidden);this.dispatchEvent(new CustomEvent('ls:casas-filter',{bubbles:true,detail:{model:b.dataset.filter}}))});}
  this.prev=this.querySelector('[data-casa-prev]');this.next=this.querySelector('[data-casa-next]');
  const move=direction=>this.track.scrollBy({left:direction*(this.track.clientWidth+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.prev?.addEventListener('click',()=>move(-1));this.next?.addEventListener('click',()=>move(1));
  this.track.addEventListener('scroll',()=>{this.update();this.querySelectorAll('video').forEach(v=>{const a=v.getBoundingClientRect(),b=this.track.getBoundingClientRect();if(a.right<=b.left||a.left>=b.right)v.pause()})},{passive:true});this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update();
  const dialog=this.querySelector('[data-casa-dialog]');const close=()=>dialog.close();
  this.querySelector('[data-casa-close]').addEventListener('click',close);dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close()}});
  dialog.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow||'';this.trigger?.focus()});
  this.querySelectorAll('[data-casa-open]').forEach(button=>button.addEventListener('click',()=>{if(button.dataset.video){this.querySelectorAll('video').forEach(v=>v.pause());const video=this.prepareVideo(button);button.hidden=true;video.hidden=false;video.play().catch(()=>{});video.focus();return}this.trigger=button;const img=dialog.querySelector('[data-casa-dialog-image]');img.src=button.dataset.large;img.alt=button.querySelector('img').alt;dialog.querySelector('[data-casa-dialog-author]').textContent='@'+button.dataset.author;const link=dialog.querySelector('[data-casa-dialog-link]');link.hidden=!button.dataset.url;if(button.dataset.url)link.href=button.dataset.url;this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();this.dispatchEvent(new CustomEvent('ls:casas-open',{bubbles:true,detail:{author:button.dataset.author,model:button.dataset.title}}))}));
 }
 prepareVideo(button){const card=button.closest('[data-casa-card]');let video=card.querySelector('video');if(video)return video;const fragment=card.querySelector('template').content.cloneNode(true);video=fragment.querySelector('video');video.hidden=true;video.muted=true;video.defaultMuted=true;video.preload='metadata';if(button.dataset.videoSrc){video.querySelectorAll('source').forEach(s=>s.remove());video.src=button.dataset.videoSrc}video.addEventListener('play',()=>this.querySelectorAll('video').forEach(v=>{if(v!==video)v.pause()}));button.after(fragment);return video;}
 update(){if(this.gallery)return;const visible=this.cards.filter(c=>!c.hidden);const overflowing=this.track.scrollWidth>this.track.clientWidth+3;this.querySelector('[data-casa-controls]').hidden=!overflowing;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-3;const current=visible.findIndex(c=>c.offsetLeft-this.track.offsetLeft>=this.track.scrollLeft-3);this.querySelector('[data-casa-progress]').textContent=String(Math.max(1,current+1)).padStart(2,'0')+' / '+String(visible.length).padStart(2,'0');}
 disconnectedCallback(){this.observer?.disconnect();this.videoObserver?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause());const dialog=this.querySelector('[data-casa-dialog]');if(dialog?.open){dialog.close();document.body.style.overflow=this.previousOverflow||''}}
}
customElements.define('ls-casas',LsCasas);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oct26-banner"] && !Shopify.designMode) return;
  try {
    
const oct26Cleanup = new WeakMap();
function initOct26(root=document){
  root.querySelectorAll('.oct26-carousel').forEach(carousel=>{
    if(carousel.dataset.initialized)return;
    carousel.dataset.initialized='true';
    const track=carousel.querySelector('.oct26-track');
    const slides=[...track.querySelectorAll('.oct26-slide')];
    if(slides.length<2)return;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const events=new AbortController();
    const options={signal:events.signal};
    const playback=carousel.querySelector('[data-oct26-autoplay]');
    let current=1;
    let settleTimer;
    let rotationTimer;
    let moving=false;
    let interacting=false;
    let paused=false;
    let inView=true;
    const copySlide=slide=>{
      const copy=slide.cloneNode(true);
      copy.setAttribute('aria-hidden','true');
      copy.inert=true;
      [copy,...copy.querySelectorAll('*')].forEach(node=>{
        node.removeAttribute('id');
        [...node.attributes].forEach(attribute=>{
          if(attribute.name.startsWith('data-shopify'))node.removeAttribute(attribute.name);
        });
      });
      copy.querySelectorAll('img').forEach(image=>{image.loading='eager';image.fetchPriority='low';});
      return copy;
    };
    track.prepend(copySlide(slides[slides.length-1]));
    track.append(copySlide(slides[0]));
    const items=[...track.children];
    const leftAt=index=>items[index].getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;
    const nearest=()=>items.reduce((best,item,index)=>Math.abs(leftAt(index)-track.scrollLeft)<Math.abs(leftAt(best)-track.scrollLeft)?index:best,0);
    const jump=index=>track.scrollTo({left:leftAt(index),behavior:'instant'});
    const update=()=>{
      const position=nearest();
      current=((position-1+slides.length)%slides.length)+1;
      slides.forEach((slide,index)=>{slide.inert=index!==current-1;});
    };
    const normalize=()=>{
      const position=nearest();
      if(Math.abs(leftAt(position)-track.scrollLeft)>2)return;
      moving=false;
      if(position===0)jump(slides.length);
      else if(position===slides.length+1)jump(1);
      update();
    };
    const move=(direction,announce=false)=>{
      normalize();
      if(moving)return;
      moving=true;
      track.scrollTo({left:leftAt(current+direction),behavior:reduced.matches?'instant':'smooth'});
      if(announce){
        const status=carousel.querySelector('[data-oct26-status]');
        const next=(current-1+direction+slides.length)%slides.length;
        if(status)status.textContent=slides[next].getAttribute('aria-label');
      }
    };
    const start=()=>{
      clearTimeout(rotationTimer);
      if(carousel.dataset.autoplay!=='true'||paused||interacting||!inView||document.hidden||reduced.matches)return;
      rotationTimer=setTimeout(()=>{move(1);start();},Number(carousel.dataset.speed)*1000);
    };
    const syncPlayback=()=>{
      if(!playback)return;
      const stopped=paused||reduced.matches;
      playback.disabled=reduced.matches;
      playback.setAttribute('aria-label',stopped?playback.dataset.playLabel:playback.dataset.pauseLabel);
      playback.querySelector('[data-oct26-pause]').hidden=stopped;
      playback.querySelector('[data-oct26-play]').hidden=!stopped;
    };
    carousel.querySelectorAll('[data-oct26-direction]').forEach(button=>button.addEventListener('click',()=>{
      move(Number(button.dataset.oct26Direction),true);
      start();
    },options));
    playback?.addEventListener('click',()=>{paused=!paused;syncPlayback();start();},options);
    track.addEventListener('pointerdown',()=>{interacting=true;clearTimeout(rotationTimer);},options);
    const endInteraction=()=>{if(!interacting)return;interacting=false;start();};
    document.addEventListener('pointerup',endInteraction,options);
    document.addEventListener('pointercancel',endInteraction,options);
    carousel.addEventListener('focusin',event=>{
      if(!event.target.closest('.oct26-controls'))clearTimeout(rotationTimer);
    },options);
    carousel.addEventListener('focusout',event=>{
      if(!event.relatedTarget||!carousel.contains(event.relatedTarget))start();
    },options);
    document.addEventListener('visibilitychange',start,options);
    reduced.addEventListener('change',()=>{syncPlayback();start();},options);
    track.addEventListener('scroll',()=>{
      update();
      clearTimeout(settleTimer);
      settleTimer=setTimeout(normalize,140);
    },{...options,passive:true});
    track.addEventListener('scrollend',normalize,options);
    const resize=new ResizeObserver(()=>{jump(current);moving=false;update();});
    resize.observe(track);
    const visibility=new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;start();},{threshold:.1});
    visibility.observe(carousel);
    oct26Cleanup.set(carousel,()=>{
      events.abort();resize.disconnect();visibility.disconnect();
      clearTimeout(rotationTimer);clearTimeout(settleTimer);
    });
    jump(current);
    update();
    syncPlayback();
    start();
  });
}
initOct26();
document.addEventListener('shopify:section:load',event=>initOct26(event.target));
document.addEventListener('shopify:section:unload',event=>{
  event.target.querySelectorAll('.oct26-carousel').forEach(carousel=>oct26Cleanup.get(carousel)?.());
});

  } catch(e) { console.error(e); }
})();
})();
